import * as React from 'react';

import './InvestmentProfileCardComponent.css';

interface Props {
  name?: string;
  investorType?: string;
  juridical: boolean;
  defaultProfile: boolean;
  activeProfile?: boolean;
  className?: string;
  expiredData?: boolean;
  ind?: number;
  onClick?: (index?: number) => void;
}

const InvestmentProfileCardComponent: React.StatelessComponent<Props> = (
  props: Props) => {

  return (
    <div className={props.className ? props.className : 'col-xs-6 col-md-6 col-lg-6'}>
      <div
        className={'pointer simple-card tab' + (props.activeProfile ? '' : ' simple-card-grey')}
        onClick={(i) => props.onClick ? (props.onClick!(props.ind)) : undefined}
      >
        <a className="btn-menu btn-circle-user">
          <span className={'circle' + (props.activeProfile ? '' : ' circle-grey')}>
            {props.name![0] + (props.name!.split(/[^A-Za-z]/)[1] ?
              props.name!.split(/[^A-Za-z]/)[1][0] : '')}
          </span>
        </a>
        <h4 className="f-s-16">
          {props.name}
          <br />
          <div className="primary-font f-w-100">
            {props.juridical ?
              'Persona Jurídica' :
              (props.investorType ?
                'Inversor' + props.investorType.toLowerCase() :
                'Persona Física')
            }
          </div>
        </h4>
        <span>{props.defaultProfile ?
          <span className="default" /> :
          null}
        </span>

        {props.expiredData ?
          <div className="expired-data">
            <span className="alerted" />
          </div> : null
        }
      </div>
    </div>
  );
};

export default InvestmentProfileCardComponent;


// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/partials/InvestmentProfileCard.component.tsx